import React from 'react';
import { textBody, textCaption } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { useScreenSize } from '../../utils/utils';
import { Image } from '../../components/Image';

import { animationImage, transitionAnimation } from './logic';
import { CardProps } from '.';

export const MultipleImageCard = ({
  className,
  logo,
  image,
  title,
  subtitle,
  as: Component = 'div',
  children,
}: CardProps) => {
  const screenSize = useScreenSize();

  const styleBox = screenSize === 'xs' ? { height: '275px' } : {};

  return (
    <Component
      className={classNames(
        'Card MultipleImageCard',
        'rounded-18 flex testimonial--quote-with-img overflow-hidden relative h-full w-full',
        'max-w-[90vw] lg:max-w-[824px]',
        className,
      )}
      style={styleBox}
    >
      {image && (
        <>
          <Image
            {...image}
            className={classNames(
              'w-full h-full rounded-18 object-cover',
              transitionAnimation,
              animationImage,
            )}
            sizes={[
              '(max-width: 350px) 313px',
              '(max-width: 480px) 429px',
              '(max-width: 768px) 688px',
              '(max-width: 768px) 788px',
              '824px',
            ]}
          />

          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))',
            }}
          />
        </>
      )}
      {(title || subtitle || logo) && (
        <div
          className={classNames(
            'absolute rounded-6 bg-neutral-1 left-24 right-24 bottom-24 sm:left-auto md:right-32 md:bottom-32 p-12',
            logo && 'flex space-x-12',
          )}
        >
          {logo && (
            <div className={'h-64'}>
              <Image
                {...logo}
                className="w-auto h-full"
                sizes={logo?.sizes || ['120px']}
              />
            </div>
          )}
          {(title || subtitle) && (
            <div className="flex-col self-center">
              {title && (
                <p
                  className={classNames(
                    textBody,
                    'text-neutral-301 font-medium',
                  )}
                >
                  {title}
                </p>
              )}
              {subtitle && (
                <p className={classNames(textCaption, 'text-neutral-301')}>
                  {subtitle}
                </p>
              )}
              {children}
            </div>
          )}
        </div>
      )}
    </Component>
  );
};
export default MultipleImageCard;
